<button
  type="{{
    (label && label.includes('Cancel')) || type === 'button'
      ? 'button'
      : 'submit'
  }}"
  class="{{ colorClasses }}"
  (click)="doClick()"
  [disabled]="disabled"
>
  <img class="mr-1 mb0-5" *ngIf="btnImage" [src]="btnImage" alt="" />
  {{ label }}
  <img
    *ngIf="showDropdownIcon"
    src="/assets/icons/arrow-down-white.svg"
    alt="v"
    class="ml-1"
  />
  <img
    *ngIf="showDarkDropdownIcon"
    src="/assets/icons/black-arrow-down.svg"
    alt="v"
    class="ml-1"
  />
</button>

<!-- Usage -->

<!-- <app-base-button
  label="Hello!"
  [colorClasses]="'custom__btn custom__btn-brand custom-btn-lg btn'"
  btnImage="/assets/arrow-left.svg"
></app-base-button> -->
